// extracted by mini-css-extract-plugin
export default {"foot":"footer_foot__7uDQk"};